import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    sendSms: {
        method: 'POST',
        url: `${BASE_PATH_API}/sms/messages`
    },
    resendSms: {
        method: 'POST',
        url: `${BASE_PATH_API}/sms/messages/:id/messageRetries`
    },
    getSmsOptIns: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/optins`,
        params: {
            '$count': true
        }
    },
    sendSmsOptIns: {
        method: 'POST',
        url: `${BASE_PATH_API}/sms/optIns`
    },
    optOutOfSMS: {
        method: 'POST',
        url: `${BASE_PATH_API}/phone/sms/optout`
    },
    getSmsUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/users`,
        params: {
            '$count': true
        }
    },
    getRecentSmsUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/users/recent`
    },
    getTotalUnreadCount: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/unread`,
        params: {
            'includeApplicants': true,
            'includeVendorsAndRentalOwners': true
        }
    },
    getUnreadCountByResident: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/unread/byResident`
    },
    markMessagesAsReadByResident: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/:id/markAsRead`
    },
    markAllMessagesAsRead: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/markAllAsRead`
    },
    getSmsUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/users/:id`
    },
    getSmsUserOptInStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/users/:id/optInStatus`
    },
    getSmsUserAssignableStaff: {
        method: 'GET',
        url: `${BASE_PATH_API}/sms/conversations/:id/staffMembers`
    },
    hasUnfollowedUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/sms/conversations/hasUnfollowed`
    },
    unfollowSmsUser: {
        method: 'POST',
        url: `${BASE_PATH_API}/sms/unfollows`,
    },
    followSmsUser: {
        method: 'POST',
        url: `${BASE_PATH_API}/sms/follows`,
    },
    getUnreadMessagesCount: {
        method: 'HEAD',
        url: `${BASE_PATH_API}/sms/unreadMessages`,
        transformResponse: function transform(data, headers) {
            return parseInt(headers.get('x-total-count'), 10);
        },
        params: {
            'includeApplicants': true,
            'includeVendorsAndRentalOwners': true
        }
    },
    getSmsRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/phone/sms/recipients`,
        params: {
            '$count': true
        }
    },
    createMessage: {
        method: 'POST',
        url: `${BASE_PATH_API}/messages`
    },
    getUserUnitAgreements: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/userUnitAgreements`
    },
    getSmsMessageById: {
        method: 'GET',
        url: `${BASE_PATH_API}/sms/messages/:id`
    },
    getProspectApplicantUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/userProspectApplicant`
    },
};

export function PhoneApi() {
    return createActions(actions);
}
